/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useApplicationTabStyles = makeStyles(() => ({
  frame: {
    position: 'relative',
    height: '900px',
    '&:hover .fullscreen-button': {
      visibility: 'visible',
    },
  },
  fullScreen: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 99999,
  },
}));
